<template>
    <div>
        <div class="bg"></div>
        <div class="u-hd">
            <div class="hd-bk" @click="closeModle">
                <i class="icon iconback" ></i>&nbsp;返回
            </div>
            <div class="hd-tl">询价单详情</div>
            <div class="hd-mu"></div>
        </div>
        <div style="height:44px"></div>
        <div class="content">
            <div style="font-size:22px;padding:10px;text-align:center">{{form.title}}</div>
            <div style="height:2px;background:#E5E3FE;margin-left:10px"></div>
            <div style="padding:10px;color:#888;font-size:12px"><span>{{form.merchantName}}</span>&nbsp;&nbsp;&nbsp;&nbsp;<span>{{form.sendTime}}</span></div>
            <div style="color:#e41616;font-weight:600;padding: 0px 20px;font-size:14px">需求数量：{{form.needCount}}</div>

            <div style="padding:20px" v-html="form.content">
            </div>
            <div style="height:2px;background:#E5E3FE;margin-left:10px"></div>
        </div>
        <div style="font-size:22px;padding:10px 20px">我要给出报价</div>
        <div style="padding:0px 20px;background: #FFF;">
            <div style="margin: 0;padding: 10px 0px 16px;color: rgba(69, 90, 100, 0.6);font-weight: normal;font-size: 14px;line-height: 16px;">请选择商品图片</div>
            <van-uploader v-model="fileList" multiple :disabled="state=='AUDIT'" :deletable="state!='AUDIT'" :after-read="afterRead" :max-size="20 * 1024 * 1024" @oversize="onOversize"/>
        </div>
        <!-- <div class="van-uploader">
            <div class="van-uploader__wrapper">
                <div class="van-uploader__upload">
                    <i class="van-icon van-icon-photograph van-uploader__upload-icon"></i>
                    <div class="van-uploader__input"></div>
                </div>
            </div>
        </div> -->
        <div style="padding:0px 20px;background-color:#FFF">
            <div style="margin: 0;padding: 10px 0px 16px;color: rgba(69, 90, 100, 0.6);font-weight: normal;font-size: 14px;line-height: 16px;">填写报价</div>
            <div style="background:#eee">
                <van-field
                    v-model="price"
                    :disabled="state=='AUDIT'"
                    style="background:#EEE;padding:10px"
                    maxlength="30"
                    placeholder="请在此处填写报价"
                />
            </div>
        </div>
        <div style="padding:0px 20px;background-color:#FFF">
            <div style="margin: 0;padding: 10px 0px 16px;color: rgba(69, 90, 100, 0.6);font-weight: normal;font-size: 14px;line-height: 16px;">填写备注信息</div>
            <div style="background:#eee">
                <van-field
                    v-model="message"
                    rows="2"
                    :disabled="state=='AUDIT'"
                    autosize
                    style="background:#EEE;padding:10px"
                    type="textarea"
                    maxlength="100"
                    placeholder="请在此处填写备注"
                    show-word-limit
                />
            </div>
        </div>
        <div style="height:70px;background-color:#FFF"></div>
        <div style="position: fixed;bottom:0px;width:100%;display:flex;width:100%;background:#4935ae;height:50px;align-items: center;font-size:15px" v-if="state=='UNAUDIT'">
            <div style="width:60px;text-align:center;color:#FFF;" @click="goHome"><van-icon name="wap-home" size="25"/></div>
            <div style="height:30px;width:1px;background-color:#FFF"></div>
            <div style="flex:1;text-align:center;color:#FFF" @click="save('UNAUDIT')"><van-icon name="passed" size="20" style="vertical-align: sub;"/>&nbsp;保存</div>
            <div style="height:30px;width:1px;background-color:#FFF"></div>
            <div style="flex:1;text-align:center;color:#FFF" @click="save('AUDIT')"><van-icon name="checked" size="20" style="vertical-align: sub;"/>&nbsp;保存提交</div>
            <div style="flex:1;text-align:center;color:#FFF;background-color:#ff8518;height:50px;line-height:50px" @click="closeModle"><i class="icon iconfanhui1"></i>&nbsp;返回</div>
        </div>
    </div>
</template>

<script>
import { Toast } from 'vant';
import {compressImage} from './CompressImageUtils'
export default {
    data() {
        return {
            form:{},
            fileList: [
            ],
            state:"UNAUDIT",
            price:'',
            message:'',
            photoList:[],
            serverIds:[],
            uploadNum:9,
        };
    },
    mounted() {
        let account = JSON.parse(window.localStorage.getItem("account"))
        // this.$request.getApi("index/wxJsInit?accessKey=" + account.accessKey+"&appId="+account.appId+"&dir=inquiryPriceDetail").then(data => {
        //     if(data.status==200){
        //         wx.config({
        //         debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        //         appId: data.content.appId, // 必填，公众号的唯一标识
        //         timestamp: data.content.timestamp, // 必填，生成签名的时间戳
        //         nonceStr: data.content.nonceStr, // 必填，生成签名的随机串
        //         signature: data.content.signature, // 必填，签名
        //         jsApiList: ["chooseImage","uploadImage"] // 必填，需要使用的JS接口列表
        //         });
        //     }else if(data.status==40100){
        //         localStorage.removeItem("token")
        //     }
        //     }).catch(err => {
        //     if (err.status == 40100) {
        //         localStorage.removeItem("token")
        //     }
        // })
        this.$request.get("inquiry/inquiryDetail/"+this.$route.query.inquiryId).then(data=>{
            if(data.status==200){
                data.content.supplierInquiry.content=decodeURIComponent(data.content.supplierInquiry.content)
                this.form=data.content.supplierInquiry
                if(data.content.backDetail){
                    if(data.content.backDetail.images){
                        this.fileList = JSON.parse(data.content.backDetail.images).map(img=>{
                            return {url:img, isImage: true}
                        })
                    }
                    this.state=data.content.backDetail.state
                    this.price=data.content.backDetail.price
                    this.message = data.content.backDetail.content
                }
            }
        })
    },
    methods: {
        onOversize(file){
            Toast('文件大小不能超过10MB');
        },
        afterRead(file) {
            if(file.length){
                // 此时可以自行将文件上传至服务器
                for(let i=0;i<this.fileList.length;i++){
                    if(this.fileList[i].status==""){
                        this.fileList[i].status= 'uploading'
                        this.fileList[i].message= '上传中...'
                        console.log(this.fileList[i])
                        compressImage(this.fileList[i].content).then(result => {
                            console.log('压缩后的结果', result); // result即为压缩后的结果
                            console.log('压缩前大小', this.fileList[i].file.size);
                            console.log('压缩后大小', result.size);
                            if (result.size > this.fileList[i].file.size){
                                this.uploadFile(this.fileList[i].file, this.fileList[i].file.name,i)
                            } else {
                                this.uploadFile(result, this.fileList[i].file.name,i)
                            }
                        })
                    }
                }
            }else{
                let index=this.fileList.length-1
                compressImage(file.content).then(result => {
                    console.log('压缩后的结果', result); // result即为压缩后的结果
                    console.log('压缩前大小', file.file.size);
                    console.log('压缩后大小', result.size);
                    if (result.size > file.file.size){
                        console.log("123")
                        this.uploadFile(file.file, file.file.name,index)
                    } else {
                        this.uploadFile(result, file.file.name,index)
                    }
                })
            }
            
        },
        uploadFile(file,fileName,i){
            var forms = new FormData()
            var configs = {
                headers:{'Content-Type':'multipart/form-data'},
                timeout: 1000 * 60 * 10
            };
            forms.append("file", file, fileName);
            this.$request.axios.post('/wxSupplier/fileupload/image',forms ,configs).then(res=>{
                if(res.status==200){
                    this.fileList[i].url=res.content.accessUrl
                    this.fileList[i].status= 'done'
                    this.fileList[i].message= ''
                }else{
                    this.fileList[i].status= 'failed'
                    this.fileList[i].message= '上传失败'
                }
            }).catch(err=>{
                console.log(err)
                    this.fileList[i].status= 'failed'
                    this.fileList[i].message= '上传失败'
            })
        },
        dealImage(path, obj, callback) {
            var img = new Image();
            img.src = path;
            img.onload = function() {
                var that = this;
                // 默认按比例压缩
                var w = that.width,
                    h = that.height,
                    scale = w / h;
                w = obj.width || w;
                h = obj.height || (w / scale);

                //生成canvas
                var canvas = document.createElement('canvas'),
                ctx = canvas.getContext('2d');
                canvas.width = w;
                canvas.height = h;
                ctx.drawImage(that, 0, 0, w, h);

                // 默认图片质量为0.7
                var quality = 0.7;
                if (obj.quality && obj.quality <= 1 && obj.quality > 0) {
                    quality = obj.quality;
                }

                // 回调函数返回base64的值
                var base64 = canvas.toDataURL('image/jpeg', quality);
                callback(base64);
            }
        },
        processData(dataUrl, type) {
            var binaryString = window.atob(dataUrl.split(',')[1]),
            arrayBuffer = new ArrayBuffer(binaryString.length),
            intArray = new Uint8Array(arrayBuffer);
            for (var i = 0, j = binaryString.length; i < j; i++) {
                intArray[i] = binaryString.charCodeAt(i);
            }

            var data = [intArray], blob;

            try {
                blob = new Blob(data);
            } catch (e) {
                window.BlobBuilder = window.BlobBuilder ||
                    window.WebKitBlobBuilder ||
                    window.MozBlobBuilder ||
                    window.MSBlobBuilder;
                if (e.name === 'TypeError' && window.BlobBuilder) {
                    var builder = new BlobBuilder();
                    builder.append(arrayBuffer);
                    blob = builder.getBlob(type);
                } else {
                    showTip('版本过低，不支持图片压缩上传');
                }
            }
            return blob;
        },
        goHome(){
            this.router.replace({path:"/"})
        },
        save(type){
            if(!this.price){
                Toast("请填写报价后提交！")
                return;
            }
            let data={
                inquiryId:this.$route.query.inquiryId,
                images:[],
                state:type,
                price:this.price,
                content:this.message
            }
            
            for(let i=0;i<this.fileList.length;i++){
                data.images.push(this.fileList[i].url)
            }
            this.$request.postJSON("inquiry/saveInquireBack",data).then(data=>{
                if(data.status==200){
                    Toast.success("保存成功")
                    this.closeModle()
                }else{
                    Toast.fail(data.message)
                }
            })
        },
        closeModle(){
            this.router.go(-1)
        }
    },
};
</script>

<style>
    .content img{
        max-width: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/views/inquiryPrice/detail.vue